
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/low-risk-business-ideas-to-start-in-2023",
      function () {
        return require("private-next-pages/page/low-risk-business-ideas-to-start-in-2023.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/low-risk-business-ideas-to-start-in-2023"])
      });
    }
  